<template>
  <div>
    <page-header/>
    <router-view class="px-16 py-8"/>
  </div>
</template>

<script>
  import PageHeader from '@/components/Header'
  import ProjectIndex from '@/pages/projects/index.vue'
  import ProjectShow from '@/pages/projects/_uuid/index.vue'
  import VueRouter from 'vue-router'

  export default {
    router: new VueRouter({
      routes: [
        { path: '/', component: ProjectIndex },
        { path: '/projects', component: ProjectIndex },
        { path: '/projects/:id', component: ProjectShow, name: 'project' }
      ]
    }),

    components: {
      PageHeader
    }
  }
</script>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;

body {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  user-select: none;
}

.only-missing-translations .document-node:not(.missing-translation) {
  display: none
}
</style>
